import { GenericProducts } from "../../../../../constants";

// the inventory of one kind of product only (laboratory Supply Management);
// without a scope every product is listed
export const SCOPES = {
  reagents: {
    title: "Reagent Inventory",
    icon: "flask",
    noun: "reagent",
    hint: "Reagents, test kits, controls, calibrators, stains and culture media",
    includes: (pgid) => GenericProducts.isReagent(pgid),
  },
  supplies: {
    title: "Supply Inventory",
    icon: "box-open",
    noun: "supply",
    hint: "Medical and general supplies",
    includes: (pgid) => !GenericProducts.isReagent(pgid),
  },
};

// why stock was dispensed as a monthly expense (server Expenses.reason)
export const REASONS = {
  correction: { label: "Count correction", color: "info" },
  expired: { label: "Expired", color: "danger" },
  damaged: { label: "Damaged", color: "warning" },
  lost: { label: "Lost / missing", color: "dark" },
  inHouse: { label: "Used in-house (QC, training...)", color: "primary" },
  other: { label: "Other", color: "light" },
};
